import { io } from "socket.io-client";
import { SOCKET_ENDPOINT } from "./config/env.js";

let socketInstance = null;

export function getSocket() {
  if (!socketInstance) {
    socketInstance = io(
      SOCKET_ENDPOINT, { 
        query: {
          client: localStorage.getItem('yootGame')
        },
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 500, // Start reconnecting after 500ms
        reconnectionDelayMax: 2000, // Max delay of 2 seconds between attempts
        reconnectionAttempts: Infinity,
        // Detect disconnects faster on mobile
        timeout: 5000, // Connection timeout (5 seconds)
        pingTimeout: 3000, // How long to wait for pong before considering disconnected (3 seconds)
        pingInterval: 5000, // How often to ping (5 seconds)
      },
    );
  }
  return socketInstance;
}

export function connectSocket() {
  const socket = getSocket();
  if (!socket.connected) {
    socket.connect();
  }
  return socket;
}

export function disconnectSocket() {
  if (socketInstance && socketInstance.connected) {
    socketInstance.disconnect();
  }
}
